export default {
  categories: [],
  paginationOrigin: {
    loading: true,
    page: 0,
    perPage: 18,
    total: 0,
    data: []
  },
  currentCate: {
    name: '',
    post_cnt: 0
  },
  currentEditor: {
    nick: '',
    slogan: '',
    position: '',
    email: '',
    post_cnt: 0
  },
  latestPosts: {},
  catePosts: {},
  tagPosts: {},
  editorPosts: {},
  searchArticles: {},
  searchGalleries: {},
  regionCountries: [],
  brands: [],
  tournaments: {},
  upcomingTournaments: [],
  events: {},
  feeds: [],
  series: [],
  albums: [],
  albumImages: [],
  datePeriod : {},
  listOfCalledAPI: [],
  displayCateData: [],
  displayData: [],
  displayPage: [],
  isUpdatedDisplayData: false,
  pageYOffset: 0,
  bigCompareSlot: false,
  bigCompareSlotPosition: 0,
  smallToastBanner: false,
  openFooter1Dialog: false,
  openFooter2Dialog: false,
  openFooter3Dialog: false,
  openFaqDialog: false,
  openTeamDialog: false,
  froalaAlertText: '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a>',
}
